import React, { useState, useRef, useEffect } from 'react';
import BaseCard from './BaseCard';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import StackJumper from './StackJumper';

// Define props interface
interface NotFoundProps {
  title?: string;
  message?: string;
}

export const NotFound: React.FC<NotFoundProps> = ({
  title = "Page Not Found", // Default title
  message = "Oops! The page you're looking for doesn't exist or has been moved." // Default message
}) => {
  const [showGame, setShowGame] = useState(false);
  const [containerDimensions, setContainerDimensions] = useState({ width: 0, height: 0 });
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      setContainerDimensions({
        width: containerRef.current.offsetWidth,
        height: containerRef.current.offsetHeight,
      });
    }
  }, []);

  const toggleGame = () => {
    if (!showGame) {
      // Update dimensions when showing the game
      if (containerRef.current) {
        setContainerDimensions({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight,
        });
      }
    }
    setShowGame(!showGame);
  };

  return (
    <BaseCard className="flex flex-col items-center justify-center min-h-[600px]">
      <div 
        ref={containerRef} 
        className="w-full h-full relative flex flex-col items-center justify-center"
        style={{ minHeight: '550px' }}
      >
        {!showGame ? (
          <>
            <div 
              className="md:w-[356px] w-[256px] cursor-pointer mx-auto" 
              onClick={toggleGame}
              title="Click to play Stack Jumper"
            >
              <DotLottieReact 
                src={`${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/assets/animations/404.lottie`}
                loop={false}
                autoplay={true}
                style={{ height: '100%', width: '100%' }}
              />
            </div>
            {/* Use title prop or default */}
            <h2 className="text-h5 font-bold text-greyscale-900 mb-2 text-center">{title}</h2>
            {/* Use message prop or default */}
            <p className="text-bodyM text-greyscale-600 text-center max-w-md mx-auto">
              {message}
            </p>
          </>
        ) : (
          <StackJumper 
            containerWidth={containerDimensions.width} 
            containerHeight={containerDimensions.height}
            onExit={toggleGame}
          />
        )}
      </div>
    </BaseCard>
  );
}; 